import { POPUP_TYPES } from "@constants/popups";

import { IPopupStatus } from "./popups.types";

export const DEFAULT_POPUP_STATUS: IPopupStatus = {
  isOpen: false,
  isBlockingPopup: false,
  dialogType: POPUP_TYPES.NOT_SELECTED,
};
